import { render, staticRenderFns } from "./ApprovedQuotes.vue?vue&type=template&id=63327aeb&scoped=true&"
import script from "./ApprovedQuotes.vue?vue&type=script&lang=js&"
export * from "./ApprovedQuotes.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedQuotes.vue?vue&type=style&index=0&id=63327aeb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63327aeb",
  null
  
)

export default component.exports